<div class="universal-search-container">
  <div class="search-bar">
    <mat-icon
      id="searchicon"
      role="img"
      matprefix
      class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color"
      aria-hidden="true"
      data-mat-icon-type="font"
    >search</mat-icon>
    <input
      type="text"
      [(ngModel)]="searchTerm"
      (input)="onSearchDebounced()"
      [placeholder]="'Search For ' + currentPlaceholder"
      class="search-input"
    />
    <button class="clear-btn" (click)="clearSearch()" *ngIf="searchTerm">×</button>
  </div>

  <div class="search-results" *ngIf="showResults"  [class.no-data]="!noData()">
    <div class="results-grid">
      <!-- Part 1: Products & Categories -->
      <div class="products-section" *ngIf="categorizedResults.products?.length > 0 || categorizedResults.categories?.length > 0">
        <h4>PRODUCTS</h4>
        <div class="suggestion-category" *ngIf="categorizedResults.products?.length > 0">
          <ul>
            <li *ngFor="let item of categorizedResults.products " (click)="navigateToItem(item, 'product')">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="suggestion-category" *ngIf="categorizedResults.categories?.length > 0">
          <h5>Categories</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.categories " (click)="navigateToItem(item, 'category')">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Part 2: Healthcare Network -->
      <div class="healthcare-network-section" *ngIf="hasHealthcareNetworkItems()">
        <h4>HEALTHCARE NETWORK</h4>
        <div *ngIf="categorizedResults.doctors?.length > 0" class="suggestion-category">
          <h5>Doctors</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.doctors " (click)="navigateToItem(item, 'doctor')">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div *ngIf="categorizedResults.hospitals?.length > 0" class="suggestion-category">
          <h5>Hospitals</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.hospitals " (click)="navigateToItem(item, 'hospital')">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div *ngIf="categorizedResults.clinics?.length > 0" class="suggestion-category">
          <h5>Clinics</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.clinics " (click)="navigateToItem(item, 'clinics')">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div *ngIf="categorizedResults.laboratories?.length > 0" class="suggestion-category">
          <h5>Laboratories</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.laboratories " (click)="navigateToItem(item, 'laboratory')">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Part 3: Brands & Distributors -->
      <div class="brands-distributors-section" *ngIf="categorizedResults.brands?.length > 0 || categorizedResults.distributors?.length > 0">
        <h4 *ngIf="categorizedResults.brands?.length > 0">BRANDS</h4>
        <div class="brand-logos" *ngIf="categorizedResults.brands?.length > 0">
          <img
            *ngFor="let brand of categorizedResults.brands"
            [src]="brand.logo || 'default-logo.png'"
            [alt]="brand.name"
            class="brand-logo"
            (click)="navigateToItem(brand, 'brand')"
          />
        </div>
        <h4 *ngIf="categorizedResults.distributors?.length > 0" class="mt-3">DISTRIBUTORS</h4>
        <div class="brand-logos" *ngIf="categorizedResults.distributors?.length > 0">
          <img
            *ngFor="let distributor of categorizedResults.distributors"
            [src]="distributor.logo || 'default-logo.png'"
            [alt]="distributor.name"
            class="brand-logo"
            (click)="navigateToItem(distributor, 'distributor')"
          />
        </div>
      </div>

      <!-- Part 4: Knowledge Center -->
      <div class="knowledge-center-section" *ngIf="categorizedResults.webinars?.length > 0 || categorizedResults.jobs?.length > 0">
        <h4>KNOWLEDGE CENTER</h4>
        <div *ngIf="categorizedResults.webinars?.length > 0" class="suggestion-category">
          <h5>Webinars</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.webinars " (click)="navigateToItem(item, 'webinar')">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div *ngIf="categorizedResults.jobs?.length > 0" class="suggestion-category">
          <h5>Jobs</h5>
          <ul>
            <li *ngFor="let item of categorizedResults.jobs " (click)="navigateToItem(item, 'job')">
              {{ item.name }}
            </li>
          </ul>
      </div>
      </div>
       <!-- Part 5: Other-secation -->
      <div class="other-sections" *ngIf="hasOtherItems()">
        <h4>Other Sections</h4>
        <div >
          <ul>
            <li *ngIf="categorizedResults.products.length" (click)="searchInSection('products')">
              <a>Search "{{ searchTerm }}" in Products</a>
            </li>
            <li *ngIf="categorizedResults.doctors.length" (click)="searchInSection('doctors')">
              <a>Search "{{ searchTerm }}" in Doctors</a>
            </li>
            <li *ngIf="categorizedResults.hospitals.length" (click)="searchInSection('hospitals')">
              <a>Search "{{ searchTerm }}" in Hospitals</a>
            </li>
            <li *ngIf="categorizedResults.clinics.length" (click)="searchInSection('clinics')">
              <a>Search "{{ searchTerm }}" in Clinics</a>
            </li>
            <li *ngIf="categorizedResults.laboratories.length" (click)="searchInSection('labs')">
              <a>Search "{{ searchTerm }}" in Labs</a>
            </li>
            <li *ngIf="categorizedResults.jobs.length" (click)="searchInSection('jobs')">
              <a>Search "{{ searchTerm }}" in Jobs</a>
            </li>
            <li *ngIf="categorizedResults.brands.length" (click)="searchInSection('brands')">
              <a>Search "{{ searchTerm }}" in Brands</a>
            </li>
            <li *ngIf="categorizedResults.distributors.length"  (click)="searchInSection('distributors')">
              <a>Search "{{ searchTerm }}" in distributors</a>
            </li>
          </ul>
        </div>
      </div>

      <div *ngIf="!noData() " class="no-match-container">
        <p class="no-matches">No results found. Please try different keywords.</p>
      </div>
  </div>
</div>